import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api/axios';
import useAuthStore from '../../store/authStore';
import toast from 'react-hot-toast';

export default function AdminLogin() {
  const [form, setForm] = useState({ phone: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { login } = useAuthStore();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post('/auth/login', form);
      if (res.data.user.role !== 'admin') {
        toast.error('Accès réservé aux administrateurs');
        return;
      }
      login(res.data.user, res.data.token);
      navigate('/admin/dashboard');
    } catch(e) { toast.error('Identifiants incorrects'); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="text-4xl mb-2">🛡️</div>
          <h1 className="text-2xl font-bold text-white">SantéTogo Admin</h1>
          <p className="text-gray-400 mt-1">Panneau d'administration</p>
        </div>
        <div className="bg-gray-800 rounded-2xl p-6 border border-gray-700">
          <form onSubmit={handleSubmit} className="space-y-4">
            <input className="w-full bg-gray-700 border border-gray-600 text-white rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
              type="tel" placeholder="Téléphone admin" value={form.phone}
              onChange={e => setForm({...form, phone: e.target.value})} required />
            <input className="w-full bg-gray-700 border border-gray-600 text-white rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
              type="password" placeholder="Mot de passe" value={form.password}
              onChange={e => setForm({...form, password: e.target.value})} required />
            <button type="submit" disabled={loading}
              className="w-full bg-green-600 text-white py-3 rounded-xl font-semibold hover:bg-green-700 transition-all disabled:opacity-50">
              {loading ? 'Connexion...' : 'Accéder au panel'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
